// Strings locales de la pantalla /roles (M3). Sin literales sueltos en JSX (docs/05 §8).
// Las claves de navegación viven en el i18n global (es.nav.roles); esto cubre el resto.
export const rolesI18n = {
  pageDescription: "Agrupaciones de scopes que se asignan a los usuarios.",
  newRole: "Nuevo rol",
  refresh: "Actualizar",
  searchLabel: "Buscar roles",
  searchPlaceholder: "Buscar por nombre",
  emptyTitle: "Aún no hay roles",
  emptyDescription: "Crea el primer rol para empezar a agrupar scopes.",
  emptyAction: "Crear el primer rol",
  // Columnas del DataGrid
  colName: "Nombre",
  colDescription: "Descripción",
  colScopes: "Scopes",
  colScope: "Alcance",
  colActions: "Acciones",
  // Alcance (dominio) de un rol
  scopeGlobal: "Instancia",
  scopeDomain: "Dominio",
  systemBadge: "Sistema",
  // Acciones de fila
  editRole: "Editar rol",
  editScopes: "Editar scopes",
  deleteRole: "Eliminar rol",
  rowActions: "Acciones del rol",
  // Drawer de alta/edición
  createTitle: "Nuevo rol",
  editTitle: "Editar rol",
  nameLabel: "Nombre",
  namePlaceholder: "p. ej. operador",
  nameHint: "Único dentro de su alcance.",
  descriptionLabel: "Descripción",
  descriptionPlaceholder: "Para qué sirve este rol (opcional)",
  // Editor de la matriz de scopes
  scopesTitle: "Scopes del rol",
  scopesSubtitle: "Marca los scopes que agrupa este rol.",
  scopesEmpty: "No hay scopes disponibles en este alcance.",
  selectedCount: (n: number) => `${n} ${n === 1 ? "scope seleccionado" : "scopes seleccionados"}`,
  saveScopes: "Guardar scopes",
  // Diálogo de borrado
  deleteTitle: "Eliminar rol",
  deleteConfirm: "Eliminar",
  deleteMessage: (name: string) =>
    `¿Eliminar el rol "${name}"? Se quitará de todos los usuarios que lo tengan. Esta acción no se puede deshacer.`,
  systemDeleteHint: "Los roles de sistema no se pueden eliminar.",
  // Validación inline
  nameRequired: "Escribe un nombre para el rol.",
  // Feedback
  createError: "No se pudo crear el rol.",
  updateError: "No se pudo guardar el rol.",
  scopesError: "No se pudieron guardar los scopes.",
  deleteError: "No se pudo eliminar el rol.",
  loadScopesError: "No se pudieron cargar los scopes.",
} as const
